function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M47.6766 137.547C29.5004 114.795 18.5424 101.066 20.5224 83.4215C22.5006 65.7932 36.2306 54.8185 58.9975 36.6609C81.7476 18.5015 95.4758 7.54346 113.104 9.52162C130.732 11.4998 141.707 25.2298 159.865 47.9967C178.024 70.7468 188.997 84.4936 187.019 102.122C185.041 119.75 171.31 130.725 148.544 148.882C125.794 167.042 112.047 178.015 94.4185 176.036C76.7903 174.058 65.8155 160.328 47.658 137.561L47.6766 137.547Z",
  fill: "#FF8FE3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M54.2427 132.305C71.5706 154.013 81.1923 166.067 95.3584 167.657C109.525 169.246 121.597 159.61 143.287 142.297C164.995 124.969 177.049 115.347 178.639 101.181C180.229 87.0149 170.592 74.9423 153.279 53.2525C135.951 31.5441 126.329 19.4901 112.163 17.9005C97.9972 16.3108 85.9246 25.9473 64.2348 43.2604C42.545 60.5735 30.4742 70.1933 28.8846 84.3595C27.2949 98.5256 36.9314 110.598 54.2445 132.288L54.2427 132.305Z",
  stroke: "#111927",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M59.3096 73.4291L66.0498 74.1855L66.8843 89.5382L66.9512 89.5457L71.6025 74.8086L79.4131 75.685L80.6992 91.0884L80.7661 91.0959L84.9491 76.3062L91.6893 77.0626L84.1183 98.5004L76.0066 97.5901L74.7501 82.3764L74.6832 82.3689L70.086 96.9257L61.9743 96.0155L59.343 73.4329L59.3096 73.4291Z",
  fill: "#111927"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M90.7192 88.1146C91.5206 80.973 96.0209 76.9393 102.443 77.66C104.684 77.9115 106.585 78.7852 108.063 80.2551C109.54 81.725 110.431 83.6031 110.697 85.9024L104.382 86.3453C104.103 84.6035 103.08 83.4557 101.709 83.3018C99.4674 83.0503 97.8018 85.065 97.4002 88.6442C96.9985 92.2233 98.4434 94.892 101.153 95.196C103.361 95.4438 105.025 94.191 105.444 91.9686L99.975 91.3549L100.41 87.4747L112.185 88.796L110.76 101.49L106.027 100.959L106.079 97.4763L106.046 97.4725C104.386 99.7419 101.641 100.958 98.8312 100.643C93.1112 100.001 89.9161 95.1206 90.7062 88.0793L90.7192 88.1146Z",
  fill: "#111927"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M115.304 79.7126L124.252 80.7166L126.657 95.6529L126.724 95.6604L132.447 81.6363L141.328 82.6329L138.858 104.643L132.854 103.969L134.511 89.2011L134.444 89.1935L128.355 103.464L123.254 102.892L120.546 87.6339L120.479 87.6264L118.822 102.395L112.817 101.721L115.287 79.7107L115.304 79.7126Z",
  fill: "#111927"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M143.67 82.8956L150.343 83.6444L147.873 105.655L141.2 104.906L143.67 82.8956Z",
  fill: "#111927"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M103.16 541.34C93.3517 541.34 86.2999 539.439 85.5396 539.211L75.1044 536.265L91.641 464.321L109.033 386.58L213.993 394.069L219.087 372.496L223.306 354.496C195.46 352.177 169.743 344.821 148.207 332.922C143.056 330.071 138.19 326.992 133.591 323.665C133.077 333.948 128.44 343.433 120.418 349.725C117.89 351.701 115.191 353.412 112.378 354.819C106.961 365.463 96.2028 373.579 83.1446 376.582C79.3051 377.457 75.6176 377.913 72.1393 377.913C68.6609 377.913 65.6197 377.514 62.5785 376.715C41.5751 375.746 23.7461 363.277 15.7629 343.889C9.66147 329.063 7.19049 307.452 17.9488 291.257L3.88317 256.055C-3.94794 236.782 0.271738 214.543 14.6795 199.451C24.6584 188.997 38.667 182.99 53.1507 182.99C59.2331 182.99 65.2395 184.036 70.9798 186.07L86.8701 191.734C94.264 164.724 111.428 141.136 137.107 122.908C167.728 101.163 209.032 87.5345 259.82 82.4025L277.801 80.5968V80.6348C279.797 80.2356 281.774 80.0646 283.446 79.9125C286.906 79.6084 292.513 79.2472 299.451 79.2472C321.385 79.2472 353.584 82.6876 382.418 99.0911C392.055 104.565 400.571 111.047 407.984 118.498C407.851 113.784 408.44 109.032 409.941 104.394C411.956 98.1407 415.853 93.3889 420.871 90.7278C424.026 73.8871 437.997 61 454.21 61C456.415 61 458.601 61.2471 460.749 61.7223C462.782 62.1785 464.74 62.8627 466.622 63.7751C469.359 62.9958 472.172 62.5966 474.966 62.5966C477.152 62.5966 479.357 62.8437 481.486 63.3189C484.432 63.9842 487.245 65.1246 489.83 66.7023C492.51 65.9039 495.247 65.4858 498.022 65.4858C510.434 65.4858 520.698 73.3359 526.173 87.0403C530.943 98.9581 532.35 113.385 530.031 126.614C527.503 141.06 520.812 152.749 511.119 159.744L522.162 230.072C524.994 248.129 518.322 265.939 504.333 277.686C497.072 283.768 488.367 287.76 479.129 289.205C476.506 289.623 473.845 289.832 471.184 289.832C465.462 289.832 459.798 288.881 454.324 287L449.534 285.327C456.814 289.737 462.592 296.503 465.748 304.715L491.256 364.493C493.385 362.935 495.589 361.452 497.908 360.046C508.8 353.355 520.109 349.953 531.514 349.953C558.942 349.953 577.379 369.626 580.268 372.914C583.29 376.088 584.887 380.441 584.773 385.269C584.317 404.352 555.444 434.593 538.47 449.457C501.311 481.979 475.841 498.478 462.801 498.478C456.282 498.478 450.922 495.132 448.451 489.506L448.28 489.107L400.742 354.267L334.824 345.163C330.357 346.227 325.757 347.159 321.081 347.976L316.044 349.002L308.479 349.782L307.548 349.896C306.692 349.991 305.837 350.105 304.963 350.2C297.113 384.071 287.457 425.204 282.287 444.724C277.212 463.903 257.748 473.654 241.801 474.585C224.428 475.612 201.619 476.999 168.412 479.033C167.329 487.054 164.934 495.227 161.266 503.439C146.554 536.417 118.518 541.34 103.103 541.34H103.16Z",
  fill: "#F2F2EF"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M477.265 274.473C470.917 275.462 464.302 274.93 457.935 272.744L363.448 239.671L379.738 190.916L456.452 217.774L444.953 140.375L495.722 132.411L510.795 228.399C513 242.484 507.811 256.359 496.9 265.521C491.141 270.349 484.355 273.39 477.265 274.511V274.473Z",
  fill: "#F2F2EF",
  stroke: "#111927",
  strokeWidth: 1.90075,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M466.089 94.6242L444.021 100.821L432.674 123.535L447.082 146.192L489.868 146.021L499.257 136.194L500.436 103.482L466.089 94.6242Z",
  fill: "#F2F2EF"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M440.449 102.684C436.096 94.2255 424.236 93.4271 420.681 104.433C415.492 120.532 425.528 139.634 436.876 148.416C442.141 152.484 447.368 154.841 452.101 156.152",
  fill: "#F2F2EF"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M440.449 102.684C436.096 94.2255 424.236 93.4271 420.681 104.433C415.492 120.532 425.528 139.634 436.876 148.416C442.141 152.484 447.368 154.841 452.101 156.152",
  stroke: "#111927",
  strokeWidth: 1.90075,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M471.887 83.9801C471.107 79.0382 466.336 71.2451 458.125 69.3823C445.618 66.5692 432.104 77.3845 431.515 93.4269C430.925 109.469 435.373 116.749 439.916 120.893C445.96 126.424 460.273 127.013 464.645 114.867",
  fill: "#F2F2EF"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M471.887 83.9801C471.107 79.0382 466.336 71.2451 458.125 69.3823C445.618 66.5692 432.104 77.3845 431.515 93.4269C430.925 109.469 435.373 116.749 439.916 120.893C445.96 126.424 460.273 127.013 464.645 114.867",
  stroke: "#111927",
  strokeWidth: 1.90075,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M492.643 85.5765C491.863 80.6345 487.092 72.8414 478.881 70.9787C466.374 68.1656 452.86 78.9809 452.271 95.0232C451.681 111.066 456.129 118.345 460.672 122.489C466.716 128.02 481.029 128.61 485.401 116.464",
  fill: "#F2F2EF"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M492.643 85.5765C491.863 80.6345 487.092 72.8414 478.881 70.9787C466.374 68.1656 452.86 78.9809 452.271 95.0232C451.681 111.066 456.129 118.345 460.672 122.489C466.716 128.02 481.029 128.61 485.401 116.464",
  stroke: "#111927",
  strokeWidth: 1.90075,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M504.16 102.037C507.506 110.533 505.909 120.474 501.195 125.093C496.481 129.712 484.868 132.696 479.298 119.543C473.71 106.352 474.965 92.9134 482.226 82.1362C489.467 71.3589 507.506 67.7855 515.508 87.8004C523.548 107.91 520.07 136.707 503.438 147.655C490.38 156.247 474.889 156.684 474.889 156.684",
  fill: "#F2F2EF"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M504.16 102.037C507.506 110.533 505.909 120.474 501.195 125.093C496.481 129.712 484.868 132.696 479.298 119.543C473.71 106.352 474.965 92.9134 482.226 82.1362C489.467 71.3589 507.506 67.7855 515.508 87.8004C523.548 107.91 520.07 136.707 503.438 147.655C490.38 156.247 474.889 156.684 474.889 156.684",
  stroke: "#111927",
  strokeWidth: 1.90075,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M450.676 215.74C434.082 221.879 428.171 257.176 444.878 268.163L394.851 250.657L409.163 201.199L450.676 215.721V215.74Z",
  fill: "#111927"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M458.811 481.428L409.106 340.449L294.281 324.597L301.846 269.76L432.979 287.874C443.034 289.262 451.512 296.028 455.085 305.532L510.682 435.848L458.792 481.447L458.811 481.428Z",
  fill: "#F2F2EF",
  stroke: "#111927",
  strokeWidth: 1.90075,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M241.059 459.703C214.012 461.299 173.735 463.77 101.544 468.237L117.89 395.172L222.736 402.661L250.544 285.08L304.411 297.815C304.411 297.815 280.405 403.421 271.186 438.319C267.404 452.613 252.065 459.056 241.059 459.722V459.703Z",
  fill: "#F2F2EF",
  stroke: "#111927",
  strokeWidth: 1.90075,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M230.072 371.66C236.44 344.555 286.924 343.319 288.711 365.919L296.77 331.212L237.39 340.544L230.091 371.66H230.072Z",
  fill: "#111927"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M395.819 337.693C385.802 305.779 407.281 283.768 432.998 287.874L371.394 279.358L323.933 328.683L395.819 337.674V337.693Z",
  fill: "#111927"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M278.846 88.4468L260.865 90.2525C144.596 101.98 87.3452 159.706 94.6061 231.688C102.874 313.705 185.766 347.368 265.465 339.213L308.65 334.804L278.846 88.4468Z",
  fill: "#111927"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M303.709 335.374C381.336 327.543 440.431 282.647 431.82 197.741C418.553 65.6382 273.506 88.9795 278.848 88.4473C201.221 96.2784 142.126 141.174 150.737 226.081C159.252 311.007 226.121 343.186 303.747 335.355H303.69L303.709 335.374Z",
  fill: "#00C16B",
  stroke: "#111927",
  strokeWidth: 1.90075,
  strokeMiterlimit: 10
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M302.208 320.301C265.181 324.027 233.115 317.963 209.47 302.757C184.019 286.373 169.288 260.047 165.733 224.522C162.122 188.978 171.284 160.239 192.952 139.102C213.062 119.486 243.284 107.132 280.311 103.387C317.338 99.6615 349.403 105.725 373.049 120.931C398.5 137.315 413.231 163.641 416.785 199.166C420.396 234.71 411.235 263.45 389.566 284.586C369.456 304.202 339.234 316.557 302.208 320.301Z",
  stroke: "#111927",
  strokeWidth: 1.90075,
  strokeMiterlimit: 10
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M311.577 311.596H311.539C309.544 311.805 307.776 310.284 307.643 308.288L305.609 276.755C305.514 275.405 306.521 274.208 307.871 274.075H307.985C309.335 273.923 310.57 274.873 310.76 276.222L315.474 308.535C315.683 309.961 314.676 311.253 313.25 311.424C312.699 311.481 312.129 311.558 311.577 311.615V311.596ZM263.964 304.335C263.089 303.954 262.215 303.574 261.36 303.175C260.067 302.567 259.516 301.008 260.143 299.735L274.703 270.52C275.311 269.304 276.775 268.791 278.01 269.342H278.048C279.284 269.912 279.873 271.357 279.379 272.611L267.328 302.966C266.796 304.297 265.275 304.924 263.964 304.354V304.335ZM353.622 293.918L335.546 266.719C334.786 265.578 335.071 264.058 336.173 263.259L336.23 263.221C337.333 262.423 338.872 262.632 339.709 263.696L359.99 289.281C360.883 290.402 360.655 292.037 359.515 292.892C358.754 293.462 357.994 294.014 357.215 294.565C356.036 295.382 354.42 295.097 353.622 293.899V293.918ZM224.827 273.561C224.257 272.801 223.687 272.022 223.135 271.242C222.318 270.064 222.603 268.448 223.801 267.65L250.981 249.574C252.122 248.814 253.642 249.099 254.441 250.201L254.479 250.239C255.277 251.342 255.068 252.881 254.004 253.718L228.438 274.018C227.317 274.911 225.682 274.702 224.808 273.542L224.827 273.561ZM385.707 257.614L356.492 243.035C355.276 242.427 354.763 240.963 355.314 239.728V239.69C355.884 238.454 357.329 237.865 358.583 238.359L388.919 250.429C390.25 250.961 390.877 252.482 390.307 253.813C389.927 254.687 389.546 255.561 389.147 256.417C388.539 257.709 386.98 258.26 385.707 257.633V257.614ZM206.295 227.297C206.181 226.347 206.086 225.377 205.991 224.427C205.858 223.001 206.941 221.728 208.366 221.652C217.414 221.139 231.936 220.207 240.926 219.561C242.295 219.466 243.492 220.473 243.625 221.842V222.013C243.778 223.362 242.846 224.579 241.497 224.788L209.184 229.521C207.758 229.73 206.466 228.723 206.295 227.297ZM360.275 212.224V212.338C360.218 211.445 360.161 210.532 360.066 209.639C359.914 208.289 360.864 207.073 362.214 206.864L394.507 202.093C395.933 201.884 397.225 202.891 397.397 204.317C397.454 204.735 397.492 205.248 397.549 205.8C397.758 207.947 396.142 209.848 393.975 210L360.256 212.205L360.275 212.224ZM245.108 193.426L214.753 181.394C213.423 180.862 212.795 179.341 213.346 178.029C213.727 177.155 214.107 176.281 214.506 175.425C215.114 174.133 216.673 173.582 217.946 174.209L247.18 188.75C248.396 189.358 248.91 190.822 248.358 192.057V192.114C247.788 193.35 246.344 193.939 245.089 193.445L245.108 193.426ZM349.212 181.47L349.174 181.413C348.376 180.31 348.566 178.771 349.65 177.934L375.215 157.615C376.336 156.722 377.971 156.931 378.845 158.091C379.415 158.851 379.986 159.63 380.518 160.39C381.354 161.569 381.05 163.185 379.853 163.983L352.691 182.097C351.55 182.857 350.03 182.572 349.231 181.47H349.212ZM263.945 168.07L243.625 142.504C242.732 141.383 242.941 139.748 244.101 138.874C244.861 138.304 245.64 137.733 246.42 137.182C247.598 136.346 249.214 136.65 250.012 137.848L268.107 165.028C268.868 166.169 268.582 167.689 267.48 168.488L267.442 168.526C266.34 169.324 264.8 169.115 263.964 168.051L263.945 168.07ZM325.643 162.386H325.586C324.351 161.816 323.761 160.371 324.256 159.117L336.268 128.762C336.8 127.431 338.321 126.804 339.633 127.355C340.507 127.736 341.381 128.116 342.237 128.515C343.529 129.123 344.08 130.682 343.453 131.955L328.931 161.189C328.323 162.405 326.86 162.918 325.624 162.367L325.643 162.386ZM295.668 157.672C294.319 157.805 293.083 156.855 292.893 155.525L288.16 123.212C287.951 121.805 288.939 120.494 290.365 120.323C291.448 120.19 292.551 120.075 293.634 119.98C295.022 119.866 296.238 120.874 296.371 122.261L299.527 154.346C299.679 155.943 298.519 157.368 296.923 157.539C296.542 157.577 296.124 157.615 295.668 157.672V157.672Z",
  fill: "#027A48"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M472.04 417.867C472.04 417.867 468.315 388.082 503.783 366.299C542.767 342.369 571.792 377.191 571.792 377.191L475.48 465.918L475.537 465.861",
  fill: "#F2F2EF"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M472.04 417.867C472.04 417.867 468.315 388.082 503.783 366.299C542.767 342.369 571.792 377.191 571.792 377.191L475.48 465.918L475.537 465.861",
  stroke: "#111927",
  strokeWidth: 1.90075,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M147.866 434.822C147.866 434.822 167.766 457.288 150.812 495.304C132.184 537.082 88.543 524.746 88.543 524.746L117.872 397.111V397.187",
  fill: "#F2F2EF"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M147.866 434.822C147.866 434.822 167.766 457.288 150.812 495.304C132.184 537.082 88.543 524.746 88.543 524.746L117.872 397.111V397.187",
  stroke: "#111927",
  strokeWidth: 1.90075,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M69.2316 316.442C69.2316 316.442 69.0795 316.499 69.0035 316.537C55.9643 321.745 41.1955 315.397 35.9874 302.358L14.4138 248.319C8.23639 233.132 11.5437 215.683 22.8722 203.804C34.2387 191.905 51.5736 187.78 67.0837 193.311L130.493 215.93C143.703 220.644 150.603 235.185 145.889 248.395C141.175 261.606 126.634 268.505 113.424 263.791L69.0035 247.939L83.2021 283.502C88.3722 296.446 82.1377 311.139 69.2696 316.423L69.2316 316.442Z",
  fill: "#F2F2EF",
  stroke: "#111927",
  strokeWidth: 1.99579,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M35.2075 286.069C15.1356 300.229 22.6626 327.391 26.217 336.058C35.7208 359.172 60.9628 367.573 84.095 358.069C107.208 348.565 118.252 322.126 108.748 298.994C104.908 289.623 98.2746 282.248 90.2154 277.401",
  fill: "#F2F2EF"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M35.2075 286.069C15.1356 300.229 22.6626 327.391 26.217 336.058C35.7208 359.172 60.9628 367.573 84.095 358.069C107.208 348.565 118.252 322.126 108.748 298.994C104.908 289.623 98.2746 282.248 90.2154 277.401",
  stroke: "#111927",
  strokeWidth: 1.99579,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M45.0723 339.992C52.2571 357.479 62.065 366.223 80.4833 362.003C92.4961 359.247 100.745 351.245 103.52 342.805",
  fill: "#F2F2EF"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M45.0723 339.992C52.2571 357.479 62.065 366.223 80.4833 362.003C92.4961 359.247 100.745 351.245 103.52 342.805",
  stroke: "#111927",
  strokeWidth: 1.99579,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M108.711 311.044C117.017 296.504 112.113 282.4 101.488 274.949C91.5088 267.954 74.0408 267.954 65.5635 281.298",
  fill: "#F2F2EF"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M108.711 311.044C117.017 296.504 112.113 282.4 101.488 274.949C91.5088 267.954 74.0408 267.954 65.5635 281.298",
  stroke: "#111927",
  strokeWidth: 1.99579,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M67.958 331.515C79.6286 346.398 98.4081 348.964 113.272 337.293C119.773 332.199 124.505 322.354 120.951 310.189C117.397 298.024 100.936 289.965 92.8199 296.37C84.0004 303.327 90.1018 316.613 94.6066 321.061",
  fill: "#F2F2EF"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M67.958 331.515C79.6286 346.398 98.4081 348.964 113.272 337.293C119.773 332.199 124.505 322.354 120.951 310.189C117.397 298.024 100.936 289.965 92.8199 296.37C84.0004 303.327 90.1018 316.613 94.6066 321.061",
  stroke: "#111927",
  strokeWidth: 1.99579,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M114.943 210.399C124.181 213.802 131.024 231.859 126.196 243.549C121.558 254.763 105.63 261.093 93.2559 256.626L116.635 265.065C128.8 269.456 142.314 263.982 148.017 252.368C154.631 238.873 148.112 222.621 134.008 217.432C128.23 215.303 121.805 212.947 114.943 210.419V210.399Z",
  fill: "#111927",
  stroke: "#111927",
  strokeWidth: 1.99579,
  strokeMiterlimit: 10
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M458.81 481.428C463.295 491.597 500.493 463.979 530.867 437.387C556.87 414.635 579.394 384.489 571.79 377.171C564.359 370.024 531.704 394.962 511.461 411.632C485.933 432.654 453.488 469.358 458.81 481.428V481.428Z",
  fill: "#111927",
  stroke: "#111927",
  strokeWidth: 1.90075,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M317.507 284.738C298.709 286.639 280.062 278.332 268.867 263.088C263.773 256.15 262.823 247.331 266.301 239.519C269.741 231.783 277.097 226.442 285.48 225.586C286.639 225.472 287.836 225.434 289.034 225.491C296.542 225.833 304.088 225.624 311.463 224.883C318.838 224.142 326.289 222.83 333.569 221.006C334.728 220.72 335.888 220.511 337.066 220.397C345.448 219.542 353.717 223.305 358.64 230.205C363.62 237.181 364.437 246 360.825 253.813C352.899 270.995 336.306 282.856 317.488 284.738H317.507Z",
  fill: "#F2F2EF",
  stroke: "#111927",
  strokeWidth: 1.90075,
  strokeMiterlimit: 10
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M288.503 237.352C278.562 236.896 272.555 248.072 278.448 256.074C286.906 267.612 301.067 274.474 316.33 272.934C331.593 271.394 344.1 261.834 350.068 248.832C354.231 239.804 346.114 230.072 336.478 232.486C320.72 236.44 304.735 238.055 288.522 237.333L288.503 237.352Z",
  fill: "#111927",
  stroke: "#111927",
  strokeWidth: 1.90075,
  strokeMiterlimit: 10
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M315.018 273.047C302.188 273.941 290.232 268.904 281.926 260.236C284.948 257.518 288.845 255.713 293.197 255.256C304.127 254.154 313.877 262.118 314.999 273.047H315.018Z",
  fill: "#F2F2EF",
  stroke: "#111927",
  strokeWidth: 1.90075,
  strokeMiterlimit: 10
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M315.018 273.047C302.188 273.941 290.232 268.904 281.926 260.236C284.948 257.518 288.845 255.713 293.197 255.256C304.127 254.154 313.877 262.118 314.999 273.047H315.018Z",
  fill: "#F2F2EF",
  stroke: "#111927",
  strokeWidth: 1.90075,
  strokeMiterlimit: 10
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M291.828 237.465L292.361 242.654C292.684 245.867 290.327 248.737 287.134 249.06L284.967 249.269C281.735 249.592 278.884 247.235 278.561 244.042L278.371 242.236C280.519 239.195 284.13 237.142 288.502 237.332C289.624 237.37 290.726 237.427 291.828 237.446V237.465Z",
  fill: "#F2F2EF",
  stroke: "#111927",
  strokeWidth: 2.05281,
  strokeMiterlimit: 10
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M305.743 237.237L306.142 241.267C306.465 244.479 304.127 247.349 300.915 247.673L298.767 247.882C295.536 248.205 292.684 245.848 292.361 242.655L291.829 237.466C296.486 237.599 301.105 237.504 305.743 237.237Z",
  fill: "#F2F2EF",
  stroke: "#111927",
  strokeWidth: 2.05281,
  strokeMiterlimit: 10
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M319.543 235.85L319.942 239.88C320.265 243.092 317.927 245.962 314.715 246.285L312.548 246.494C309.336 246.817 306.465 244.46 306.142 241.267L305.743 237.237C310.362 236.971 314.962 236.496 319.543 235.85Z",
  fill: "#F2F2EF",
  stroke: "#111927",
  strokeWidth: 2.05281,
  strokeMiterlimit: 10
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M333.227 233.284L333.759 238.473C334.082 241.685 331.744 244.555 328.532 244.878L326.365 245.087C323.153 245.411 320.283 243.054 319.96 239.86L319.561 235.831C324.141 235.165 328.703 234.329 333.246 233.284H333.227Z",
  fill: "#F2F2EF",
  stroke: "#111927",
  strokeWidth: 2.05281,
  strokeMiterlimit: 10
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M347.388 235.28L347.578 237.085C347.901 240.298 345.544 243.168 342.351 243.491L340.184 243.7C336.972 244.023 334.101 241.666 333.778 238.473L333.246 233.284C334.33 233.037 335.394 232.771 336.477 232.504C340.716 231.44 344.67 232.733 347.388 235.28Z",
  fill: "#F2F2EF",
  stroke: "#111927",
  strokeWidth: 2.05281,
  strokeMiterlimit: 10
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M342.711 224.521C358.773 224.521 371.793 211.501 371.793 195.44C371.793 179.378 358.773 166.358 342.711 166.358C326.65 166.358 313.63 179.378 313.63 195.44C313.63 211.501 326.65 224.521 342.711 224.521Z",
  fill: "#F2F2EF",
  stroke: "#111927",
  strokeWidth: 1.90075,
  strokeMiterlimit: 10
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M347.445 194.946L358.032 197.797C357.652 200.401 356.588 202.948 354.782 205.134C349.403 211.71 339.709 212.699 333.151 207.319C326.575 201.959 325.586 192.265 330.965 185.689C336.325 179.131 346.019 178.143 352.596 183.503C354.782 185.29 356.34 187.571 357.253 190.042L347.464 194.946H347.445Z",
  fill: "#111927"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M325.624 154.821C319.922 153.262 316.329 147.522 317.527 141.668C318.762 135.547 324.75 131.594 330.87 132.829L359.838 138.721C365.958 139.938 369.912 145.944 368.676 152.065C367.441 158.185 361.453 162.139 355.333 160.903L326.365 155.011C326.118 154.954 325.871 154.897 325.624 154.84V154.821Z",
  fill: "#F2F2EF",
  stroke: "#111927",
  strokeWidth: 1.90075,
  strokeMiterlimit: 10
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M318.668 211.805C318.668 211.805 324.636 204.601 343.568 202.701C360.18 201.028 369.551 206.673 369.551 206.673C368.487 209.22 367.042 211.653 365.198 213.915C355.048 226.327 336.782 228.171 324.37 218.04C322.127 216.196 320.227 214.105 318.668 211.805Z",
  fill: "#00C16B",
  stroke: "#111927",
  strokeWidth: 1.91976,
  strokeMiterlimit: 10
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M275.653 231.288C291.714 231.288 304.734 218.268 304.734 202.207C304.734 186.145 291.714 173.125 275.653 173.125C259.592 173.125 246.571 186.145 246.571 202.207C246.571 218.268 259.592 231.288 275.653 231.288Z",
  fill: "#F2F2EF",
  stroke: "#111927",
  strokeWidth: 1.90075,
  strokeMiterlimit: 10
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M280.385 201.712L290.973 204.563C290.592 207.167 289.528 209.714 287.722 211.9C282.343 218.477 272.649 219.465 266.092 214.086C259.515 208.726 258.527 199.032 263.906 192.456C269.266 185.898 278.96 184.91 285.536 190.27C287.722 192.056 289.281 194.337 290.193 196.808L280.404 201.712H280.385Z",
  fill: "#111927"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M251.608 218.572C251.608 218.572 257.577 211.368 276.508 209.468C293.121 207.795 302.492 213.44 302.492 213.44C301.427 215.987 299.983 218.42 298.139 220.682C287.989 233.094 269.723 234.938 257.311 224.807C255.068 222.963 253.167 220.872 251.608 218.572Z",
  fill: "#00C16B",
  stroke: "#111927",
  strokeWidth: 1.91976,
  strokeMiterlimit: 10
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M285.31 178.239C285.177 178.239 285.044 178.239 284.911 178.239L256.665 178.277C250.412 178.277 245.356 173.221 245.337 166.967C245.318 160.714 250.393 155.62 256.646 155.639L284.892 155.601C291.145 155.601 296.201 160.657 296.22 166.91C296.22 173.031 291.392 178.01 285.329 178.22L285.31 178.239Z",
  fill: "#F2F2EF",
  stroke: "#111927",
  strokeWidth: 1.90075,
  strokeMiterlimit: 10
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M425.983 146.496L414.483 150.963",
  stroke: "#111927",
  strokeWidth: 3.80151,
  strokeMiterlimit: 10
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M405.511 113.289L394.677 121.976",
  stroke: "#111927",
  strokeWidth: 3.80151,
  strokeMiterlimit: 10
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M442.443 193.141L428.967 197.759",
  stroke: "#111927",
  strokeWidth: 3.80151,
  strokeMiterlimit: 10
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M425.489 279.377L416.062 271.489",
  stroke: "#111927",
  strokeWidth: 3.80151,
  strokeMiterlimit: 10
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M372.953 90.3661L366.681 102.702",
  stroke: "#111927",
  strokeWidth: 3.80151,
  strokeMiterlimit: 10
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M210.952 88.3326L214.64 101.429",
  stroke: "#111927",
  strokeWidth: 3.80151,
  strokeMiterlimit: 10
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M199.072 91.6589L202.741 104.774",
  stroke: "#111927",
  strokeWidth: 3.80151,
  strokeMiterlimit: 10
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M301.085 75.3123L299.735 90.1382",
  stroke: "#111927",
  strokeWidth: 3.80151,
  strokeMiterlimit: 10
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M152.142 110.001L160.581 121.824",
  stroke: "#111927",
  strokeWidth: 3.80151,
  strokeMiterlimit: 10
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M143.683 327.504L155.6 317.867",
  stroke: "#111927",
  strokeWidth: 3.80151,
  strokeMiterlimit: 10
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M109.489 146.248L122.091 156.512",
  stroke: "#111927",
  strokeWidth: 3.80151,
  strokeMiterlimit: 10
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M194.568 333.111L193.446 345.561",
  stroke: "#111927",
  strokeWidth: 3.80151,
  strokeMiterlimit: 10
});

function SvgKiwiAbout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 585,
    height: 542,
    viewBox: "0 0 585 542",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiwiAbout);
export default __webpack_public_path__ + "static/media/Kiwi_About.87689e78.svg";
export { ForwardRef as ReactComponent };